import { writable } from 'svelte/store'

import dayjs from 'dayjs'


const INTERVAL_SECS = 30

const createStore = function () {
  const start = function (set) {
    const interval = setInterval(() => set(dayjs()), INTERVAL_SECS * 1000)
    return () => clearInterval(interval)
  }

  const { subscribe, set } = writable(dayjs(), start)

  const refresh = function () {
    set(dayjs())
  }

  return {
    subscribe,
    refresh,
  }
}

const approxNowStore = createStore()

export default approxNowStore
